// First-party telemetry identifiers. A random id (no PII) persisted in
// localStorage identifies the browser across visits; a per-tab session id
// lives in sessionStorage. The server salts+hashes the raw id — the raw value
// is never stored server-side.

const AID_KEY = "annexi_aid";
const SID_KEY = "annexi_sid";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

function safeGet(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode etc.) — telemetry degrades to per-load ids */
  }
}

let memoryAid = null;
let memorySid = null;

export function getAnonRawId() {
  let aid = safeGet(window.localStorage, AID_KEY) || memoryAid;
  if (!aid) {
    aid = randomId();
    memoryAid = aid;
    safeSet(window.localStorage, AID_KEY, aid);
  }
  return aid;
}

export function getSessionId() {
  let sid = safeGet(window.sessionStorage, SID_KEY) || memorySid;
  if (!sid) {
    sid = randomId();
    memorySid = sid;
    safeSet(window.sessionStorage, SID_KEY, sid);
  }
  return sid;
}

export function telemetryHeaders() {
  return {
    "x-annexi-aid": getAnonRawId(),
    "x-annexi-sid": getSessionId(),
  };
}
